module.exports = __webpack_public_path__ + "img/icon-0.81be84c1.png";